import http, { reqDefaultConfig } from "./http";
import { useRequest } from "ahooks";

let apiPath = {
  qryShopProdItemPage: "/item/shopProdItem/qryShopProdItemPage",
  getShopProdItemInfo: "/item/shopProdItem/getShopProdItemInfo",
};

export const useQryShopProdItemPage = () => {
  const { data, runAsync, error, loading } = useRequest(
    (q) => {
      return http(
        {
          url: apiPath.qryShopProdItemPage,
          method: "get",
          data: q || {},
        },
        { noAlias: false }
      );
    },
    {
      manual: true,
      ...reqDefaultConfig,
    }
  );
  // console.log(loading,'lodd');
  return {
    result: data,
    loading,
    error,
    getList: runAsync,
  };
};

/**
 * 获取商品详情
 * @param query
 * @param requestOpt
 * @returns {{result: ({}|*|{}), getDetail: (...params: any[]) => Promise<unknown>, loading: boolean, error: Error}}
 */
export const useGetShopProdItemInfo = (query, requestOpt) => {
  const { data, runAsync, error, loading } = useRequest(
    () => {
      return http({
        url: apiPath.getShopProdItemInfo,
        method: "get",
        data: query,
      });
    },
    { manual: true }
  );

  const goodsDetailParse = (obj) => {
    if (!obj) return {};

    let detail = obj.data;
    let skuList = detail.skuList || [];
    let specList = detail?.specList[0]?.specNameValueList || [];
    let specListRes = skuList.map((sku) => {
      let res = {};
      res.specName = sku.specName;
      res.specName1 = sku.specName1;
      res.specValue1 = sku.specValue1;
      res.specName2 = sku.specName2;
      res.specValue2 = sku.specValue2;
      res.specSkuId = sku.itemSkuId;
      res.price = sku.price;
      res.stockNum = sku.stockNum;
      return res;
    });
    // let specListRes = specList.map(spec => {
    //   let res = {};
    //   skuList.forEach((sku) => {
    //     if (spec === sku.specValue1) {
    //       res.specName = spec;
    //       res.specSkuId = sku.itemSkuId;
    //       res.price = sku.price;
    //       res.stockNum = sku.stockNum;
    //     }
    //   });
    //   return res;
    // });

    detail.maxPrice = Number(detail.maxPrice);
    if (detail.maxPrice === detail.minPrice) {
      detail.priceArea = detail.maxPrice;
    } else {
      detail.priceArea = `${detail.minPrice} ~ ${detail.maxPrice}`;
    }

    detail.specListRes = specListRes;
    obj.data = detail;
    return obj;
  };

  return {
    result: goodsDetailParse(data) || {},
    loading,
    error,
    getDetail: runAsync,
  };
};
